// lib/polyfills/modern-polyfill.js
// 2026-10-29 (Aaron): we target Safari 15.4+ / iOS Safari 15.4+ and matching
// 2022+ Chrome, Edge and Firefox (see browserslist.production in
// package.json). Everything in Next.js's built-in polyfill-module
// (Array#at/flat/flatMap, Object.fromEntries/hasOwn, String#trimStart/
// trimEnd) is native on those browsers, so next.config.ts aliases that module
// to this file. The only gap left is URL.canParse (Safari 15.4-16.x), so it is
// the one guard kept here. Plain ES5 on purpose.
if (typeof URL !== "undefined" && !("canParse" in URL)) {
  URL.canParse = function (u, b) {
    try {
      new URL(u, b);
      return true;
    } catch (e) {
      return false;
    }
  };
}
